import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeatureflagService } from '../../services/featureflag.service';

@Injectable({ providedIn: 'root' })
export class FolderApiInterceptor implements HttpInterceptor {
  constructor(private featureFlagService: FeatureflagService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // if (!this.featureFlagService.featureFlagsCollection['IMAGE_MANAGER_V2']) {
    //   return next.handle(req);
    // }

    if (req.url.includes('api/FileManager_v2/TreeView/getAllFolders', 0) && req.method === 'GET') {
      const fileReq = req.clone({ headers: req.headers.set('api-version', '2.0') });
      return next.handle(fileReq);
    }
    return next.handle(req);
  }
}
